'use client'

import { Fragment } from 'react'

import { List } from '@marketplace-web/common-components/list-ui'
import { BumpOptionModel } from '@marketplace-web/vas/vas-data'

import BumpOptionListItem from './BumpOptionListItem'

type Props = {
  selectedOptionId: string
  bumpOptions: Array<BumpOptionModel>
  isLoading: boolean
  onSelect: (selectedOption: BumpOptionModel) => void
}

const BumpOptionList = ({ onSelect, bumpOptions, selectedOptionId, isLoading }: Props) => {
  const handleOptionSelect = (option: BumpOptionModel) => () => {
    onSelect(option)
  }

  return (
    <List>
      {bumpOptions.map(option => (
        <Fragment key={option.id}>
          <BumpOptionListItem
            bumpOption={option}
            onSelect={handleOptionSelect(option)}
            isSelected={option.id === selectedOptionId}
            isLoading={isLoading}
          />
        </Fragment>
      ))}
    </List>
  )
}

export default BumpOptionList
